import React from 'react';
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import StopIcon from '@mui/icons-material/Stop';
import { Box, IconButton, MenuItem, TextField, Typography } from '@mui/material';

import { BackgroundSoundListItemResponseDto } from '@shared/services/apiService/apiService';

import { useStyles } from './styles';

export type SoundSelectRowProps = {
  label: string;
  disabled: boolean;
  value: string;
  options: BackgroundSoundListItemResponseDto[];
  missingValueLabel?: string;
  allowNone?: boolean;
  noneLabel?: string;
  isPlaying: boolean;
  canPreview: boolean;
  previewButtonLabel?: string;
  onChange: (nextSoundId: string) => void;
  onTogglePreview: () => void;
};

export const SoundSelectRow: React.FC<SoundSelectRowProps> = ({
  label,
  disabled,
  value,
  options,
  missingValueLabel,
  allowNone = false,
  noneLabel,
  isPlaying,
  canPreview,
  previewButtonLabel,
  onChange,
  onTogglePreview,
}) => {
  const { classes } = useStyles();

  return (
    <Box className={classes.row}>
      <Typography variant="body2">{label}</Typography>
      <TextField
        select
        fullWidth
        size="small"
        disabled={disabled}
        value={value}
        slotProps={{
          select: {
            displayEmpty: allowNone,
            renderValue: (selected) => {
              if (selected === '') {
                return noneLabel ?? '';
              }

              return (
                options.find((sound) => sound.id === selected)?.name ?? missingValueLabel ?? ''
              );
            },
          },
        }}
        onChange={(event) => onChange(event.target.value)}>
        {allowNone ? <MenuItem value="">{noneLabel}</MenuItem> : null}
        {missingValueLabel && value && !options.some((sound) => sound.id === value) ? (
          <MenuItem value={value} disabled>
            {missingValueLabel}
          </MenuItem>
        ) : null}
        {options.map((sound) => (
          <MenuItem key={sound.id} value={sound.id}>
            {sound.name}
          </MenuItem>
        ))}
      </TextField>
      <IconButton
        color="primary"
        disabled={disabled || !canPreview}
        onClick={onTogglePreview}
        aria-label={previewButtonLabel}>
        {isPlaying ? <StopIcon /> : <PlayArrowIcon />}
      </IconButton>
    </Box>
  );
};

export default SoundSelectRow;
